import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import logoimg from '../assets/MK1.3.png';
import {setToken,getToken,removeToken} from "../Data/authToken.js";


function LogoPage() {

  const navigate = useNavigate();

  const getCredentials = async () => {
    try {
      const credentials = getToken();
      if (credentials) {
        return credentials;
      } else {
        console.log('No token found');
        return null;
      }
    } catch (error) {
      console.error('Error retrieving token:', error);
      return null;
    }
  };

  const handleClick = ()=>{
    const checkCredentials = async () => {
      try {
        const token = await getCredentials();
        console.log(token);
        if (token) {
          console.log(token)
          navigate('/paging');
        } else {
          navigate('/login');
        }
      } catch (error) {
        console.error('Error checking credentials:', error);
      }
    };
    checkCredentials();
  }

  return (
    <div className=' bg-[white] text-white flex flex-col min-h-screen text-xl font-bold pb-40 '>
      <img className=' w-[70%] ml-[15%] lg:w-[40%] lg:ml-[30%] mt-[100px] rounded-full' src={logoimg} alt="mohamed khamis" />
      <span onClick={handleClick} className='ml-auto mr-auto px-20 py-4 bg-[#e44d73] rounded-full mt-[190px] lg:mt-[80px] cursor-pointer'>ابدأ</span> 
    </div>
  )

}

export default LogoPage
